<template>
  <div class="flex px-12 items-center justify-center customplancls">
    <div class="w-full">
      <div class="w-full">
        <div class="flex items-center gap-4 ml-4">
          <img src="@/assets/images/BA 5.png" alt="image" class="w-24" />
          <h2
            class="lg:font-semibold md:font-semibold font-bold lg:text-3xl md:text-2xl text-xl"
          >
            Let's select a subscription<br />
            plan to get started
          </h2>
        </div>
      </div>
      <swiper
        :options="swiperOption"
        class="mySwiper mt-4 flex overflow-hidden"
        ref="mySwiper"
      >
        <!-- <div class="grid lg:grid-cols-4 grid-cols-1 gap-4 role"> -->
        <swiper-slide
          v-for="(plan, index) in filteredPlans"
          :key="plan._id"
          class="bg-white shadow-md p-2 rounded-16px h-730px relative"
          v-show="index < plans.length"
        >
          <div
            class="px-5 py-8 rounded-16px"
            :class="[
              plan.name == 'Business'
                ? 'bg-primary'
                : plan.name == 'Enterprise'
                ? 'bga6277a'
                : plan.name == 'Essential'
                ? 'bgprimary-light'
                : 'col-ed',
            ]"
          >
            <div class="flex gap-4" v-if="plan.name != 'Business'">
              <img
                v-if="['Free', 'Starter', 'Prototype'].includes(plan.name)"
                class="w-5 h-5"
                src="@/assets/images/new-log/dworld.png"
                alt="white8"
              />
              <img
                v-if="plan.name == 'Essential'"
                class="w-5 h-5"
                src="@/assets/images/new-log/white.png"
                alt="white"
              />
            </div>
            <div
              v-if="plan.name == 'Business' || plan.name == 'Enterprise'"
              class="flex gap-2"
            >
              <img
                class="w-5 h-5 apps-gl object-contain"
                src="@/assets/images/Vector (2).png"
                alt="white"
              />
              <img
                class="w-5 h-5 object-contain apps-glr"
                src="@/assets/images/Vector (3).png"
                alt="white2"
              />
              <img
                class="w-5 h-5 object-contain"
                src="@/assets/images/Vector (4).png"
                alt="white3"
              />
            </div>
            <h1
              class="fsize20 mt-2 font-semibold"
              :class="[
                plan.name == 'Business' || plan.name == 'Enterprise'
                  ? 'text-white'
                  : plan.name == 'Essential'
                  ? 'text-white'
                  : 'text-393939',
              ]"
            >
              {{ plan.name }} <br />subscription
            </h1>
          </div>
          <div class="flex mt-5 justify-center">
            <div>
              <div class="block text-center 0 mb-4 mt-4">
                <h2
                  class="text-dark font-bold fsize18"
                  v-if="plan.plans.length < 2 && plan.name != 'Enterprise'"
                >
                  {{
                    parseInt(plan.plans[0].price) === 0
                      ? "Forever Free"
                      : `${plan.plans[0].price.toLocaleString()}`
                  }}
                </h2>
                <h2
                  class="text-dark font-bold fsize18"
                  v-if="plan.plans.length > 1"
                >
                  {{ plan.currency
                  }}{{
                    plan.selected === false
                      ? plan.plans[0].price
                      : plan.plans[1].price
                  }}
                  <span class="fsize12"
                    >{{
                      selectedProject.countryCode.iso2 === "IN"
                        ? "/ Yearly"
                        : plan.selected === false
                        ? "/ Month"
                        : "/ Yearly"
                    }}
                  </span>
                  <p class="fsize10">billed annually</p>
                  <div></div>
                </h2>
                <div
                  v-if="
                    selectedProject.countryCode.iso2 !== 'IN' &&
                    plan.name !== 'Enterprise'
                  "
                >
                  <vs-switch v-model="plan.selected" />
                </div>
                <h2
                  class="text-dark font-bold fsize18"
                  v-if="plan.name == 'Enterprise'"
                >
                  {{ plan.currency }}{{ plan.plans[0].price }}
                  <span class="fsize12"> / Month </span>
                  <!-- <p class="fsize10">billed annually</p> -->
                  <div></div>
                </h2>
              </div>
              <div
                class="grid grid-cols-1 gap-2 text-left mt-3"
                v-for="(feature, index) in plan.features"
                :key="'feature' + index"
              >
                <p
                  class="font-semibold fsize12 text-center text-424242"
                  :class="{
                    'text-primary': feature.status,
                    'text-grey': !feature.status,
                  }"
                >
                  {{ feature.text }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="absolute bottom-0 pb-5 w-11/12 pl-2 lett-0 flex btnfix"
            v-if="index < plans.length - 1"
          >
            <button
              class="w-full cursor-pointer col-ed border-none rounded-12px fsize14 font-semibold py-4"
              @click="selectedPlan(plan)"
            >
              Get Started
            </button>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      switch1: false,
      planDuration: true,
      Planchoose: "",
      filteredPlans: "",
      swiperOption: {
        slidesPerView: 3.5,
        observer: true,
        observeParents: true,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    selectedPlan(plan) {
      const PlanDetails = {
        plan: plan,
        billing:
          plan.selected == false
            ? plan.plans[0]
            : plan.plans[1]
            ? plan.plans[1]
            : plan.plans[0],
      };
      this.Planchoose = PlanDetails;
      this.$store.commit("scope/SET_PLAN", PlanDetails);
      this.$emit("next");
    },
    newPlans() {
      this.filteredPlans = this.plans
        // .filter((x) => x.name !== "Free")
        .sort((a, b) => a.number - b.number)
        .map((x) => {
          return { ...x, selected: true };
        });
    },
    bookDemo() {
      window.open("https://meet.brained.app/#/customer/book-a-demo", "_blank");
    },
  },
  async mounted() {
    let plans = await this.$store.dispatch("scope/getPlans");
    await this.newPlans();
    this.$store.commit("scope/EMPTY_PLATFORMS");
    this.$store.commit("scope/SET_CURRENT_PAGE", "pagePlans");
    this.$store.commit("scope/UNSET_VALIDATE_PLATFORM", false);
    await this.$store.dispatch("user/getProject", {
      projectId: this.selectedProject._id,
    });
  },
  computed: {
    ...mapState("scope", ["plans", "offerActivated"]),
    ...mapState("user", ["selectedProject"]),
  },
};
</script>
<style>
.bgprimary-light {
  background: #cd319778 !important;
}
.col-ed {
  background: #ededed !important;
}
</style>
